import { Component, OnInit } from '@angular/core';
import { PrifactRoute } from '../../../../models/prifact-route';
import { RoutingService } from '../../../../services/routing-service/routing.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {

  constructor(private routingService: RoutingService) { }

  ngOnInit() {
  }

  redirectToHome() {
    let route = new PrifactRoute();
    route.clear_history = true;
    route.url = "pages/dashboard";
    this.routingService.navigate(route);
  }
}
